<template>
  <section class="portal-apps-section">
    <h2 class="portal-apps-section__heading">
      {{ $t("portalHome.benefits.headingStart") }}
      <span>{{ $t("portalHome.benefits.headingHighlight") }}</span>
      {{ $t("portalHome.benefits.headingEnd") }}
    </h2>

    <div class="portal-apps-section__tabs" role="tablist">
      <button
        type="button"
        role="tab"
        class="portal-apps-section__tab"
        :class="{ 'portal-apps-section__tab--active': activeTab === 'myApps' }"
        :aria-selected="activeTab === 'myApps'"
        @click="activeTab = 'myApps'"
      >
        {{ $t("portalHome.benefits.tabs.myApps") }}
      </button>
      <button
        type="button"
        role="tab"
        class="portal-apps-section__tab"
        :class="{ 'portal-apps-section__tab--active': activeTab === 'allApps' }"
        :aria-selected="activeTab === 'allApps'"
        @click="activeTab = 'allApps'"
      >
        {{ $t("portalHome.benefits.tabs.allApps") }}
      </button>
    </div>

    <p class="portal-apps-section__hint">
      {{
        activeTab === "myApps"
          ? $t("myApps.myAppsDescription")
          : $t("myApps.allAppsDescription")
      }}
    </p>

    <Loader v-if="loading" :show="true" />

    <template v-else>
      <p
        v-if="activeTab === 'myApps' && myAppsList.length === 0"
        class="portal-apps-section__empty"
      >
        {{ $t("portalHome.benefits.emptyMyApps") }}
      </p>

      <div v-show="visibleApps.length > 0" class="portal-apps-section__grid" role="tabpanel">
        <PortalAppCard
          v-for="app in visibleApps"
          :key="app.id"
          :app="app"
          @request-access="requestAppAccess"
        />
      </div>
    </template>
  </section>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";

import Loader from "@/components/General/Loader/index.vue";
import PortalAppCard from "@/components/PortalHome/PortalAppCard.vue";
import { usePortalDealerApps } from "@/composables/usePortalDealerApps";

const { apps, loading, loadDealerApps, requestAppAccess } = usePortalDealerApps();

const activeTab = ref("myApps");

function isMyApp(app) {
  const status = app.status_for_user;
  return status == 1 || status == 2;
}

const allAppsList = computed(() => apps.value);

const myAppsList = computed(() => allAppsList.value.filter(isMyApp));

const visibleApps = computed(() =>
  activeTab.value === "myApps" ? myAppsList.value : allAppsList.value,
);

onMounted(() => {
  loadDealerApps();
});
</script>

<style scoped lang="scss">
@import "@/styles/portal-home/portal-apps-section";
</style>
